<template>
    <div>
    
    
        <b-modal id="modal-class-details" ref="modal-class-details" no-close-on-backdrop ok-title="Close" scrollable centered button-size="sm" size="lg" title="Class Details">
    
            <b-table  :fields="detail_fields" :items="detail_items" responsive="lg">
                <template #cell(name)="data">
            {{ data.item.name }}
</template>

<template #cell(Popularity)="data">
    <b-progress :value="data.value.value" max="100" :variant="data.value.variant" striped />
</template>

<template #cell(status)="data">
    <b-badge pill :variant="data.item.status">
        {{ data.item.status_text }}
    </b-badge>
</template>

      <!-- A virtual composite column -->
<template #cell(price)="data">
     {{ '$'+data.value }}
</template>

      <!-- Optional default data cell scoped slot -->
<template #cell()="data">
     {{ data.value }}
</template>
    </b-table>
<template #modal-footer="{ ok , closeModal }">
    <!-- Button with custom close trigger value -->
    <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
    </b-button>
</template>
  </b-modal>



      <b-row>
        <b-col  sm="12">
          <b-row>
        <b-col>
        <statistic-card-horizontal
          icon="UsersIcon"
          color="warning"
          :statistic="'0'"
          statistic-title="已報名學生"
        />
      </b-col>
      <b-col>

        <statistic-card-horizontal
          icon="CheckIcon"
          color="success"
          :statistic="'9'"
          statistic-title="成班數量"
        />
      </b-col>
      <b-col>
        <statistic-card-horizontal
          icon="TrendingUpIcon"
          color="danger"
          :statistic="'3'"
          statistic-title="未成班數量"
        />
      </b-col>
    </b-row>
          <b-card>
       <b-row>
         <b-col
           cols="12"
           md="2"
           class="align-items-center justify-content-start mb-1 mb-md-0"
         >
         </b-col>
         <b-col
           cols="12"
           md="5"
           class="align-items-center justify-content-start mb-1 mb-md-0"
         >
       </b-col>
       
         <b-col
           cols="12"
           md="5"
         >    
           <div class="d-flex align-items-center justify-content-end">           
             <!-- <flat-pickr
             v-model="rangeDate"
             class="form-control mb-1 mr-1"
             :config="{ mode: 'range'}"
           />
             <b-button
               variant="primary"
               class="mb-1"
               @click="exportToExcel()"
             >
               <span class="text-nowrap">Export</span>
             </b-button> -->
           </div>
         </b-col>
       </b-row>
       <!-- <b-row>
         <b-col
        
       >
         <statistic-card-horizontal
           icon="TrendingUpIcon"
           color="success"
           :statistic="stats.total_invoice"
           statistic-title="Pending Amount"
         />
       </b-col>
       <b-col
       
       >
         <statistic-card-horizontal
           icon="DollarSignIcon"
           :statistic="'$'+stats.total_amount"
           statistic-title="Pending"
         />
       </b-col>
       <b-col
        
       >
         <statistic-card-horizontal
           icon="TargetIcon"
           color="warning"
           :statistic="'$'+stats.total_commission"
           statistic-title="Calculation"
         />
       </b-col>
     </b-row> -->
       <!-- table -->
    <b-table
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="items"
      :fields="fields"
      responsive
      striped
      @row-selected="onRowSelected"
    >
<template #cell(status)="data">
    <b-badge :variant="data.item.status.toLowerCase()">
        {{ data.item.status_text }}
    </b-badge>
</template>
<template #cell(action)="data">
   <b-button size="sm" variant="primary">
        Confirm
    </b-button>
</template>
       </b-table>
       </b-card>
       </b-col>
        
       </b-row>
   
     </div>
   </template>
   
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
    BListGroup,
    BListGroupItem,
    BTable,
    BCard,
    BAvatar,
    BCardBody,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BInputGroupPrepend,
    BModal,
    VBModal
} from 'bootstrap-vue'
export default {
    components: {
        moment,
        BListGroup,
        BListGroupItem,
        flatPickr,
        BTable,
        ToastificationContent,
        StatisticCardHorizontal,
        BModal,
        VBModal,
        BAvatar,
        BCard,
        BBadge,
        BRow,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BButton,
        BPagination,
        BCardCode,
        BTable,
        BButton,
        BFormGroup,
        BAvatar,
        BCardBody,
        BBadge,
        vSelect,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            detail_fields: [
                // A virtual column that doesn't exist in items
                { key: 'index', label: '#' },
                // A column that needs custom formatting
                { key: 'name', label: 'Name' },
                // A regular column
                { key: 'payment_method', label: 'Payment Method' },
                // A regular column
                { key: 'status', label: 'Status' },
                // A virtual column made up from two fields

            ],
            detail_items: [
    {
        index: 1,
        name: 'Chan Siu Man',
        payment_method: 'Alipay HK',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 2,
        name: 'Lee Tai Man',
        payment_method: 'Visa',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 3,
        name: 'Peter',
        payment_method: '',
        status: 'warning',
        status_text: 'Pending'
    },
    {
        index: 4,
        name: 'Mary Chan',
        payment_method: '',
        status: 'warning',
        status_text: 'Pending'
    },
    {
        index: 5,
        name: 'Wong Ka Hei',
        payment_method: 'Mastercard',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 6,
        name: 'Ng Mei Ling',
        payment_method: '',
        status: 'warning',
        status_text: 'Pending'
    },
    {
        index: 7,
        name: 'Chan Ho Ming',
        payment_method: 'FPS',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 8,
        name: 'Leung Wai Man',
        payment_method: 'PayMe',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 9,
        name: 'Cheung Wing Sze',
        payment_method: '',
        status: 'warning',
        status_text: 'Pending'
    },
    {
        index: 10,
        name: 'Lau Chi Kin',
        payment_method: 'Visa',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 11,
        name: 'Ho Pui Yee',
        payment_method: '',
        status: 'warning',
        status_text: 'Pending'
    },
    {
        index: 12,
        name: 'Tang Chun Wai',
        payment_method: 'Alipay HK',
        status: 'success',
        status_text: 'Paid'
    },
    {
        index: 13,
        name: 'Lam Ka Yan',
        payment_method: 'FPS',
        status: 'success',
        status_text: 'Paid'
    },
],


            iframe_src: '//cloudfit.pro/invoice.php',
            rangeDate: null,
            searchString: null,
            selectMode: 'single',

            type: 'all',
            selected_user: null,
            earn: null,
            test_string: null,
            classes: [],

            headerTitle: [],
            headerVal: [],
            users: [],
            isAddNewMemberSidebarActive: false,
            searchString: null,
            perPage: 10,
            startRow: 1,
            endRow: 10,
            totalAmount: 0,
            pageOptions: [10, 15, 20],
            totalRows: 1,
            currentPage: 1,
            fields: [],
            /* eslint-disable global-require */
            items: [],
            /* eslint-disable global-require */
            status: [{
                    1: 'Active',
                    2: 'Disabled',
                    3: 'Rejected',
                    4: 'Resigned',
                    5: 'Applied',
                },
                {
                    1: 'light-success',
                    2: 'light-danger',
                    3: 'light-danger',
                    4: 'light-warning',
                    5: 'light-info',
                }
            ],
            selectMode: 'single',
            selected: [],
        }
    },
    watch: {

        rangeDate: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        currentPage: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        searchString: {
            handler(newValue, oldValue) {
                // console.log("search")
                this.searchString = newValue.toUpperCase()
                this.handleSearch()
            },
        },
        perPage: {
            handler(newValue, oldValue) {
                if (newValue < 9) {
                    this.perPage = 10
                }
                // console.log("search")
                this.handleSearch()
            },
        },
    },
    created() {
        this.get_data()
    },
    methods: {
        onRowSelected() {
            this.$refs['modal-class-details'].show()
        },
        exportToExcel() {
            import ('@/@core/Export2Excel').then(excel => {
                const list = this.items

                const data = this.formatJson(this.headerVal, list)
                console.log(data)
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: 'invoice',
                    autoWidth: true,
                    bookType: 'xlsx'
                })
                //this.clearFields()
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v =>
                filterVal.map(j => {
                    return v[j]
                })
            )
        },

        get_data(searchString = null) {
            var splitted = []
            if (this.rangeDate === null) {
                splitted[0] = moment().subtract(7, 'days').format('YYYY-MM-DD')
                splitted[1] = moment().format("YYYY-MM-DD")
                this.rangeDate = moment().subtract(7, 'days').format('YYYY-MM-DD') + " to " + moment().format("YYYY-MM-DD")
            } else {
                splitted = this.rangeDate.split(" to ");
            }
            var diff = moment(splitted[1], 'YYYY-MM-DD').diff(moment(splitted[0], 'YYYY-MM-DD'), "days")
            if (diff > 31) {
                alert("Date range must less than 30 days")
                return
            }
            this.$http.get(process.env.VUE_APP_API_BASE + `/report/interest-class/?string=` + searchString + `&from=` + splitted[0] + `&to=` + splitted[1])
                .then(res => {
                    this.fields = res.data.fields
                    this.headerTitle = res.data.excel_fields
                    this.headerVal = res.data.excel_values
                    this.items = res.data.records
                    this.totalRows = this.items.length
                    console.log(this.items)
                })
        },

        handleChangePage() {

            //  this.get_data()
        },

        close() {
            this.$refs['modal-class-details'].hide()
        },
        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },
        selectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.selectRow(2)
        },
        unselectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.unselectRow(2)
        },

        handleSearch() {
            // let _print = `The user searched for: ${searching}\n`
            // this.$refs.pre.appendChild(document.createTextNode(_print))
            // this.searchString = searching
            // this.currentx = 1
            // this.get_data()
            this.searchTimeOut()
        },
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                // your code
                this.currentPage = 1
                this.get_data(this.searchString)
            }, 500)
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss">
.b-table-selectable {
    .feather {
        font-size: 1.3rem;
    }
}

.programme {
    white-space: nowrap;
    font-family: "Ubuntu Mono", monospace; // font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
}
</style>
   